import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const SpecialOfferValueContext =
  createContext<typeof initialState>(initialState);

const SpecialOfferActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { SpecialOfferActionContext, SpecialOfferValueContext };
